var _rect, _rect2, _rect3, _rect4, _circle, _line, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdpDataLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 80,
    viewBox: "0 0 240 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 18,
    fill: "#0F766E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 53,
    width: 8,
    height: 14,
    rx: 2,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 43,
    width: 8,
    height: 24,
    rx: 2,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 35,
    width: 8,
    height: 32,
    rx: 2,
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 22,
    r: 11,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 30,
    x2: 71,
    y2: 37,
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 38,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 700,
    fill: "#111827"
  }, "PDP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 60,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 400,
    fill: "#6B7280"
  }, "Data")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdpDataLogo);
export default __webpack_public_path__ + "static/media/PDPDataLogo.6c8d5874beeb6a49162f8da944e3b6b4.svg";
export { ForwardRef as ReactComponent };